export default class GridParametros {
    constructor(){
        this.OperacaoRemota = false
        this.Paginacao = {
            quantidade: 0,
            pagina: 0
        };
        this.Ordenacao = {
            campo: '',
            crescente: true,
        };
        this.Periodo = {
            campo : '',
            inicio:'',
            fim:'',
        }
        this.Filtros  = [];
        this.PesquisaGeral = '';
    }

    limparNulosFiltros(){
        this.Filtros = this.Filtros.filter(x => !!x.valor);
    }

    resetOrdenacao(){
        this.Ordenacao.campo = '';
        this.Ordenacao.crescente = true;
    }

}